import React from 'react'
import SunRise from '../photos/SunRise.png'
import './css/advertising.css'
import Navbar from './Navbar';
import { useState } from 'react';

const Advertising = () => {
  const [myMode,setMymode] =useState("light");

  return (
  <>   
  <Navbar className="nav-cont" setMymode={setMymode}/>
      <div className='container hiring' style={{width:"100%",height:"285px",background:"#E4ECF7",display:"flex",alignItems:"center",justifyContent:"space-around",padding:"0 4px"}}>

        <div className='text' >
            {/* <h1>Hire the best developers and designers around!</h1> */}
            <h1>Welcome to your programming career journey</h1>
        </div>
        <div>
            <div className='parent'>
            <img src={SunRise} alt='' className='img'/>
            <button className='hire-btn' style={{padding:"17px 25px",borderRadius:"5px", border:"1px solid #F16063",background:"#F16063",color:"white",height:"85px"}} >Begin Your Journey
            <h2 style={{color:"red",fontSize:"15px"}}>SOON...</h2>
            </button>
            </div>
        </div>
    </div>
  </>

  )
}

  export default Advertising